import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPersonalPickups({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_PERSONAL_PICKUPS_REQUEST')

        return axios
            .get(`/personal-pickups/personal-pickups${paginate}${query}`)
            .then(response => {
                commit('GET_PERSONAL_PICKUPS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PERSONAL_PICKUPS_FAILURE')
                handleApiError(error, 'Pobranie listy odbiorów osobistych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPersonalPickup(context, id) {
        return axios
            .get(`/personal-pickups/personal-pickups/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do odbioru osobistego ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getPackages(context, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        return axios
            .get(`/personal-pickups/packages${paginate}${query}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do odbiorów osobistych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createPersonalPickupForPackage({ commit }, payload) {
        return axios
            .post('/personal-pickups/create-personal-pickup-for-package', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Odbiór osobisty został dodany.'
                }, {root: true})
                
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie odbioru osobistego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createPersonalPickup({ commit }, personalPickupData) {
        return axios
            .post('/personal-pickups/create-personal-pickup', personalPickupData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Odbiór osobisty został dodany.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie odbioru osobistego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updatePersonalPickup({ commit }, personalPickupData) {
        return axios
            .put(`/personal-pickups/personal-pickups/${personalPickupData.id}`, personalPickupData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Odbiór osobisty został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis odbioru osobistego nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deletePersonalPickup({ commit }, id) {
        return axios
            .delete(`/personal-pickups/personal-pickups/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Odbiór osobisty został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie odbioru osobistego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPersonalPickupsOrders({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_PERSONAL_PICKUPS_ORDERS_REQUEST')

        return axios
            .get(`/personal-pickups/orders${paginate}${query}`)
            .then(response => {
                commit('GET_PERSONAL_PICKUPS_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PERSONAL_PICKUPS_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień z odbiorem osobistym nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setPersonalPickupsOrdersFilters({ commit }, filters) {
        commit('SET_PERSONAL_PICKUPS_ORDERS_FILTERS', filters)
    },
    clearPersonalPickupsOrdersFilters({ commit }) {
        commit('CLEAR_PERSONAL_PICKUPS_ORDERS_FILTERS')
    }
}
